import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const TruckDetail = ({ isOpen, onCancel, message, list, chkall = false }) => {
  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={onCancel}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader>{message}</ModalHeader>
        <ModalBody style={{ whiteSpace: "pre" }}>
          {!chkall && list && list.length > 0 && (
            <div className="row border-bottom ">
              <div className="col-lg-4  col-sm-6 col-xs-12 mb-2">
                <span className="me-2" style={{ fontSize: "15px" }}>
                  สถานที่ทำงาน:
                </span>
                <span
                  className="badge rounded-pill bg-primary me-2 "
                  style={{ fontSize: "15px" }}
                >
                  {list[0].branchName}
                </span>
              </div>
              <div className="col-lg-4  col-sm-6 col-xs-12">
                <span className="me-2" style={{ fontSize: "15px" }}>
                  ประเภทรถ:
                </span>
                <span
                  className="badge bg-info text-dark me-2 "
                  style={{ fontSize: "15px" }}
                >
                  {list[0].carType_Name}
                </span>
              </div>
            </div>
          )}
          {list &&
            list.length > 0 &&
            list.map((item, index) => (
              <div
                key={item.id}
                className="row mt-2 border-bottom"
                style={{ fontSize: "14px" }}
              >
                <div className="row">
                  <div className="col-lg-4  col-sm-6 col-xs-12 ms-3">
                    {item.statusid === 2 ? (
                      <span
                        style={{ fontSize: "14px" }}
                        className="badge rounded-pill bg-success me-1 "
                      >
                        {index + 1}
                      </span>
                    ) : item.statusid === 3 ? (
                      <span
                        style={{ fontSize: "14px" }}
                        className="badge rounded-pill bg-warning text-dark me-1 "
                      >
                        {index + 1}
                      </span>
                    ) : item.statusid === 4 ? (
                      <span
                        style={{ fontSize: "14px" }}
                        className="badge rounded-pill bg-danger me-1 "
                      >
                        {index + 1}
                      </span>
                    ) : (
                      <span
                        style={{ fontSize: "14px" }}
                        className="badge rounded-pill bg-secondary me-1 "
                      >
                        {index + 1}
                      </span>
                    )}

                    <span style={{ fontSize: "14px" }}>
                      หมายเลขรถ: {item.Car_Number}
                    </span>
                  </div>
                </div>

                 {chkall && <>


                  <div className="col-lg-4  col-sm-6 col-xs-12">
                <span className="me-2" style={{ fontSize: "15px" }}>
                  ประเภทรถ:
                </span>
                <span
                  className="badge bg-info text-dark me-2 "
                  style={{ fontSize: "15px" }}
                >
                  {item.carType_Name}
                </span>
              </div>

              <div className="col-lg-4  col-sm-6 col-xs-12 mb-2">
                <span className="me-2" style={{ fontSize: "15px" }}>
                  สถานที่ทำงาน:
                </span>
                <span
                  className="badge rounded-pill bg-primary me-2 "
                  style={{ fontSize: "15px" }}
                >
                  {item.branchName}
                </span>
              </div>

                 </>}
                {item.statusid === 2 || item.statusid === 3 ? (
                  <>
                    <div className="col-lg-4  col-sm-6 col-xs-12">
                      <p style={{ fontSize: "15px" }}>
                        ทำงานล่าสุดเมื่อ : {item.lastactive}
                      </p>
                    </div>

                    <div className="col-lg-4  col-sm-6 col-xs-12">
                      <p style={{ fontSize: "15px" }}>
                        คนขับ : {item.drivenname}
                      </p>
                    </div>
                  </>
                ) : null}
              </div>
            ))}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={onCancel}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default TruckDetail;
